import * as React               from 'react';
import {
    PaletteMode,
    ThemeProvider,
    createTheme,
    CssBaseline
}                               from '@mui/material';
import useLocalStorage          from 'hooks/useLocalStorage';
import {
    ColorModeContext,
    getDesignTokens
}                               from 'style/Theme';
import * as locales             from '@mui/material/locale';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns }       from '@mui/x-date-pickers/AdapterDateFns';
//import useMedia                 from 'hooks/useMedia';

interface Children {
    children: React.ReactNode;
}

export default function ThemeConfig({ children }: Children) {
    const preferDark = false; //useMedia<boolean>(["(prefers-color-scheme: dark)"], [true], false);
    const [mode, setMode] = useLocalStorage<PaletteMode>('mode', preferDark? 'dark': 'light');
    const colorMode = React.useMemo(
        () => ({
            toggleColorMode: () => {
                setMode(
                    (prevMode: PaletteMode) => (prevMode === 'light' ? 'dark' : 'light')
                );
            }
        }),
        [setMode]
    );
    const theme = React.useMemo(
        () => createTheme(getDesignTokens(mode) as any, locales['enUS']),
        [mode]
    );

    return (
        <ColorModeContext.Provider value={colorMode}>
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <CssBaseline enableColorScheme />
                    { children }
                </LocalizationProvider>
            </ThemeProvider>
        </ColorModeContext.Provider>
    );
}